import api from './../services/api.js'

export default {
  namespaced: true,
  state: {
    doclist: null
  },
  mutations: {
    setDocs(state, docs) {
      state.doclist = docs
    }
  },
  actions: {
    getOdDocs: ({commit}) => {
      api.getDocs().then((resp) => {
        commit('setDocs', resp.data)
        return data
      })
    },
  }
}
